import api, { adminApiPrefix } from './Api';
import {
  DiscountAtCheckout,
  discountAtCheckoutFromResponse,
  discountAtCheckoutToUpsertRequest,
} from '../interfaces/DiscountAtCheckout/DiscountAtCheckout';

const discountAtCheckoutAdminApiPrefix = `${adminApiPrefix}/discount-at-checkout`;

export const getDiscountsAtCheckout = async (): Promise<
  DiscountAtCheckout[]
> => {
  const response = await api.get(discountAtCheckoutAdminApiPrefix);

  return (response.data?.data ?? []).map(discountAtCheckoutFromResponse);
};

export const updateDiscountsAtCheckout = async (
  discounts: DiscountAtCheckout[],
): Promise<void> =>
  api.put(discountAtCheckoutAdminApiPrefix, {
    updates: discounts.map(discountAtCheckoutToUpsertRequest),
  });
